import type { Form } from '../../../../../services/formService';

/**
 * Groups form fields by task group ID (e.g., '1.1', '2.1')
 * Returns an object where keys are task group IDs and values are arrays of fields for that group.
 */
export function groupFieldsByTask(fields: Form['fields']): Record<string, Form['fields']> {
  return fields.reduce((groups: Record<string, Form['fields']>, field: any) => {
    if (!field.path.includes('WorkCompleted')) return groups;
    const taskMatch = field.path.match(/WorkCompleted\.Tasks (\d+\.\d+)/);
    if (!taskMatch) return groups;
    const taskGroupId = taskMatch[1];
    if (!groups[taskGroupId]) {
      groups[taskGroupId] = [];
    }
    groups[taskGroupId].push(field);
    return groups;
  }, {});
} 